document.addEventListener('DOMContentLoaded', () => {
  const downloadFile = document.querySelectorAll('.download');

  downloadFile?.forEach(download => {
    const downloadTxt = download.querySelector('.download__txt');
    const downloadLink = download.querySelector('.download__link');

    const downloadPath = downloadLink.getAttribute('href');

    const downloadName = downloadPath.split('/').pop();

    downloadTxt.textContent = `${downloadTxt.textContent} ${downloadName}`;
  });
});

// <div class="emb-download">
//   <ul>
//     <li class="download">
//       <a href="./img/content/content_1.jpg" class="download__link" download>
//         <span class="download__txt">text</span>
//       </a>
//     </li>
//   </ul>
// </div>;
